import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";
import StatusBadge from "@/components/app/StatusBadge";

const TONE = (s) => (s >= 90 ? "green" : s >= 70 ? "blue" : s >= 50 ? "amber" : "red");

export default function DataQuality() {
  const navigate = useNavigate();
  const [summary, setSummary] = useState(null);
  const [lowest, setLowest] = useState([]);
  useEffect(() => {
    api.get("/quality/summary").then(({ data }) => setSummary(data));
    api.get("/quality/lowest", { params: { limit: 30 } }).then(({ data }) => setLowest(data.items || []));
  }, []);

  return (
    <div className="space-y-6 max-w-[1400px]">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.08em] uppercase text-slate-500">Asset Intelligence</div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900 tracking-tight">Data Quality</h1>
        <p className="text-sm text-slate-500 mt-0.5">Every golden record scored 0–100 across 14 required fields.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          ["Total records", summary?.total],
          ["Complete (100)", summary?.complete],
          ["Medium (60-99)", summary?.incomplete_medium],
          ["High priority (<60)", summary?.incomplete_high_priority],
        ].map(([label, value]) => (
          <div key={label} className="bg-white border border-slate-200 rounded-md p-4">
            <div className="text-[10px] uppercase tracking-widest text-slate-500">{label}</div>
            <div className="text-3xl font-heading font-bold text-slate-900 tabular-nums mt-1">
              {value ?? "…"}
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-slate-200 rounded-md">
        <div className="px-4 py-3 border-b border-slate-100 font-heading font-semibold text-slate-900">Lowest-scoring assets</div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[10px] uppercase tracking-widest">
            <tr>
              <th className="px-3 py-2 text-left">Score</th>
              <th className="px-3 py-2 text-left">Asset</th>
              <th className="px-3 py-2 text-left">Serial</th>
              <th className="px-3 py-2 text-left">Model</th>
            </tr>
          </thead>
          <tbody>
            {lowest.map((a) => (
              <tr key={a.id} onClick={() => navigate(`/assets?q=${a.serial}`)} className="border-t border-slate-100 hover:bg-slate-50 cursor-pointer">
                <td className="px-3 py-2"><StatusBadge value={`${a.score}`} tone={TONE(a.score)} /></td>
                <td className="px-3 py-2 font-mono text-xs">{a.asset_tag}</td>
                <td className="px-3 py-2 font-mono text-xs">{a.serial}</td>
                <td className="px-3 py-2">{a.brand} {a.model}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
